import { CssBaseline } from '@mui/material';
import { chameleonTheme } from '@mvf/external-components';
import { useRouter } from 'next/router';
import { ApolloProvider } from '@apollo/client';
import { Global, ThemeProvider } from '@emotion/react';
import { client } from '../src/Services/Gateway/Apollo';
import FormLoaderError from '../src/Components/FormLoaderError/FormLoaderError';
import makeGlobalStyling from '../styles/makeGlobalSlyles';

const FormLoaderErrorPage = () => {
  const router = useRouter();
  const { supportId, message } = router.query;

  return (
    <ThemeProvider theme={chameleonTheme}>
      <CssBaseline />
      <Global styles={makeGlobalStyling()} />
      <ApolloProvider client={client}>
        <FormLoaderError
          supportId={supportId}
          message={decodeURIComponent(message)}
        />
      </ApolloProvider>
    </ThemeProvider>
  );
};

export default FormLoaderErrorPage;
